import styled from 'styled-components'

const WrapFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export { WrapFooter }
